export { initializeIcons } from '@fluentui/font-icons-mdl2';

export type {
  // eslint-disable-next-line deprecation/deprecation
  IconNames,
} from '@fluentui/font-icons-mdl2';
